/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSchnellauswahlDto } from '../../models/create-schnellauswahl-dto';
import { SchnellauswahlDto } from '../../models/schnellauswahl-dto';

export interface CreateSchnellauswahl$Json$Params {
  
    /**
     * Daten der neuen Schnellauswahl
     */
    body?: CreateSchnellauswahlDto
}

export function createSchnellauswahl$Json(http: HttpClient, rootUrl: string, params?: CreateSchnellauswahl$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchnellauswahlDto>> {
  const rb = new RequestBuilder(rootUrl, createSchnellauswahl$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchnellauswahlDto>;
    })
  );
}

createSchnellauswahl$Json.PATH = '/v1/schnellauswahl/create';
